import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import { EnvService } from './env.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RestProvider {
  public items: any = [];
  httpOptions: any;
  hdrs: HttpHeaders;

  constructor(private httpClient : HttpClient,
              private env: EnvService,
              public router: Router) {
  }

  //Login Member
  public loginSSOMember(clientId: string, payload: any): Observable<any> {
    this.hdrs = new HttpHeaders({
      'Accept':'application/json',
      'Content-Type':'application/json'
    });
    return this.httpClient.post(this.env.CORE_API_URL+'/authorization/login/patient/sso/'+clientId,payload,{headers:this.hdrs}).pipe(
      retry(1), catchError(error => {
        return throwError(error.message);
      }));
  }

  //Get All Genders
  public getGenders(): Observable<any> {
    return this.httpClient.get('./assets/data/lists/genders.json',this.httpOptions).pipe(
      retry(1), catchError(error => {
        return throwError(error.message);
      }));
  }

  //Get All States
  public getStates(): Observable<any> {
    return this.httpClient.get('./assets/data/lists/states.json',this.httpOptions).pipe(
      retry(1), catchError(error => {
        return throwError(error.message);
      }));
  }

}
